import {  req,reqJson } from './axiosFun';
export const addApp = (params) => { return reqJson("/api/ubiboat_website/application/addOrUpdate",params) };
export const addKey = (params) => { return reqJson("/api/ubiboat_website/application-key/add",params) };
export const getAppList = (params) => { return req("post","/api/ubiboat_website/application/list/",params) };
export const getAppQuotaList = (params) => { return req("post","/api/ubiboat_website/application/list/quota",params) };
export const deleteApp = (params) => { return req("post","/api/ubiboat_website/application/delete",params) };
export const deleteKeyApi = (params) => { return req("post","/api/ubiboat_website/application-key/delete",params) };
export const getApiStatistics = (params) => { return req("post","/api/ubiboat_website/api_statistics/list",params) };



// WEBPACK FOOTER //
// ./src/api/appMG.js